import React, { useState } from "react";
import routes, { switchRoutes } from "routes.js";
import { Redirect } from "react-router-dom";
import {isAuth} from "components/auth/Helpers.js";
import logo from "assets/img/logo.png";


export default function NoAuth({ ...rest }) {

  return (switchRoutes);
}
